import { from } from "rxjs/observable/from"

export { tomyradiantComponent } from './tomyradiant/cmp'


// WEBPACK FOOTER //
// ./src/components/Button/index.ts